
export default function Merits() {
  const merits = [
    {
      icon: 'ri-magic-line',
      title: 'ポイント自動値引き！交換の手間ゼロ',
      description: 'Gold Time最大の特徴は、貯まったポイントが自動でJデポ（請求時値引き）に交換されること。ポイント交換を忘れて失効する心配がなく、毎月のカード利用代金から自動で値引きされます。サブスクコンテンツの料金も自動でおトクに！ポイントに振り回されない、ストレスフリーなカードライフを実現します。',
      highlight: 'ポイント失効の心配なし！全自動で値引き',
    },
    {
      icon: 'ri-coin-line',
      title: '通常の2倍！200円で2ポイント付与',
      description: 'ジャックスの標準ポイント「ラブリィポイント」は200円で1ポイントですが、Gold Timeは基本ポイントが通常の2倍！200円で2ポイント（還元率1.0%）が貯まります。さらに外食利用（3,000円以上）や分割・リボ払いでは200円で4ポイント（還元率2.0%）に！JACCSモール経由のネットショッピングなら+0.5〜最大12%のJデポも付与されます。',
      highlight: '外食・分割払いでポイント4倍！',
    },
    {
      icon: 'ri-plane-line',
      title: '空港ラウンジ無料＆充実の旅行保険',
      description: '国内主要空港およびハワイ・ホノルル空港のラウンジが無料で利用可能。海外・国内旅行傷害保険は最高3,000万円が付帯し、旅行前にカードで旅行代金を支払うだけで保険が適用されます。カード盗難保険やネットあんしんサービスも付帯しており、安心してカードを利用できます。',
      highlight: 'ゴールドカードならではの充実サービス！',
    },
  ];

  return (
    <section className="py-16 bg-gradient-to-br from-[#1A1A2E] to-[#16213E]">
      <div className="max-w-5xl mx-auto px-4">
        <h2 className="text-2xl md:text-3xl font-bold text-white mb-3 text-center">
          ジャックス Gold Timeの3つのメリット
        </h2>
        <p className="text-gray-400 text-center mb-12">ポイント自動値引きで手間いらずのゴールドカード</p>

        <div className="space-y-6">
          {merits.map((merit, index) => (
            <div key={index} className="bg-white/10 backdrop-blur-sm rounded-xl shadow-lg p-6 md:p-8 hover:bg-white/15 transition-all border border-white/10">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-r from-[#C9A227] to-[#E8D48B] rounded-full flex-shrink-0">
                  <i className={`${merit.icon} text-[#1A1A2E] text-xl`}></i>
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-3 flex-wrap">
                    <span className="bg-gradient-to-r from-[#C9A227] to-[#E8D48B] text-[#1A1A2E] text-xs font-bold px-3 py-1 rounded-full">
                      メリット{index + 1}
                    </span>
                    <h3 className="text-lg md:text-xl font-bold text-white">{merit.title}</h3>
                  </div>
                  <p className="text-gray-300 text-sm md:text-base leading-relaxed mb-3">
                    {merit.description}
                  </p>
                  <div className="bg-[#C9A227]/20 border-l-4 border-[#C9A227] px-4 py-2 rounded">
                    <p className="text-[#E8D48B] text-xs md:text-sm font-medium">
                      <i className="ri-information-line mr-1"></i>
                      {merit.highlight}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
